module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/00eae4b48844a30b2f6926525e0ccdea.png";